module.exports = __webpack_public_path__ + "static/media/notification.a5274e6c.png";